import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrWrapperTwoColumnsModule } from '../tr-wrapper-two-columns/tr-wrapper-left-column.module';
import { TrSpinnerButtonDirectiveModule } from '../../directives';
import { ModalModule } from '../modal/modal.module';
import { ModalWelcomePiComponent } from './modal-welcome-pi.component';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
        TrWrapperTwoColumnsModule,
        TrSpinnerButtonDirectiveModule,
    ],
    exports: [ModalWelcomePiComponent],
    declarations: [ModalWelcomePiComponent],
})
export class ModalWelcomePiModule { }
